import BoxWrap2Props from "./BoxWrap2Props.interface";
import setStyles from "./helpers/setStyles";
import styles from "./BoxWrap2.module.scss";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent } from "react";

// eslint-disable-next-line react/display-name
const BoxWrap2: FunctionComponent<BoxWrap2Props> = React.forwardRef<HTMLDivElement, BoxWrap2Props>((props, ref): JSX.Element => {
    const { containerStyles, containerClasses } = setStyles(props, styles);
    const className = combineClasses(styles.wrapper, containerClasses, props.className);

    return (
        <div className={className} style={containerStyles} ref={ref}>
            <div className={styles.inner}>
                {props.children}
            </div>

            {props.content.backgroundMedia?.[0] && props.content.backgroundMedia.length > 0 ? (
                <div className={styles.background}>
                    <BackgroundMedia {...props.content.backgroundMedia[0]} />
                </div>
            ) : null}
        </div>
    );
});

export default BoxWrap2;